// SharedPriceQuantityFields.jsx
import React from "react";
import { Grid, TextField } from "@mui/material";

const SharedPriceQuantityFields = ({
  item,
  updateItem,
  rawCents,
  setRawCents,
}) => {
  const handleQuantityChange = (e) => {
    const val = e.target.value.replace(/\D/g, ""); // strip non-digits
    updateItem(item._id, { quantity: parseInt(val || "0", 10) });
  };

  const handleUnitPriceChange = (e) => {
    const digit = e.target.value.replace(/\D/g, "").slice(0, 8); // Limit to 8 digits
    setRawCents(digit);

    const price = parseFloat((parseInt(digit || "0", 10) / 100).toFixed(2));
    updateItem(item._id, { unitPrice: price });
  };

  const handleNoteChange = (e) => {
    updateItem(item._id, { note: e.target.value });
  };

  return (
    <>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Quantity"
          type="number"
          fullWidth
          value={item.quantity}
          onChange={handleQuantityChange}
          InputProps={{
            inputProps: {
              inputMode: "numeric",
              pattern: "[0-9]*",
            },
            onWheel: (e) => e.target.blur(),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <TextField
          label="Unit Price"
          fullWidth
          value={
            rawCents
              ? (parseInt(rawCents, 10) / 100).toFixed(2)
              : (item.unitPrice || 0).toFixed(2)
          }
          onChange={handleUnitPriceChange}
          InputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            onWheel: (e) => e.target.blur(),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          label="Item Notes"
          fullWidth
          multiline
          rows={2}
          value={item.note || ""}
          onChange={handleNoteChange}
          placeholder="Optional notes or requests (e.g., less sweet, change border color)"
        />
      </Grid>
    </>
  );
};

export default SharedPriceQuantityFields;
